import { CountryCode, State } from 'types';

export const defaultState: State = {
  countryCode: 'NZ' as CountryCode,
  source: 'smp-nz',
  flow: 'proof-of-income',
  assessmentId: '',
  correlationId: '',
  accessToken: '',
  latitudeId: '',
  error: null,
  contactDetails: {
    mobileNumber: '',
    emailAddress: '',
    confirmEmail: '',
  },
  verification: {
    verificationLocked: false,
    maskedMobileNumber: '',
    oktaAuthTxn: null,
    attemptingFactorType: null,
    oktaProfileHealthy: true,
  },
  method: null,
  fiConnect: {
    userToken: '',
    guid: '',
  },
  tealium: {
    poiStartDate: '',
    bankSelected: '',
    numberOfAccountsSelected: '',
    numberOfTransactionsSelected: '',
  },
  complete: false,
  dev: false,
};

export const initialState = defaultState;
